import React, { Fragment, useState, useEffect } from 'react'
import axios from 'axios'
import QrReader from "react-qr-reader";

import { Row, Col, Input, Table, Button } from 'reactstrap'

// Import Event Management components 
import UpdateRegistration from '../components/EventManagement/UpdateRegistration'
import RegistrationTable from '../components/EventManagement/RegistrationTable'
import QrScanner from '../components/EventManagement/QRScanner'

// Import API config object
import { tokenConfig } from '../utils/apiConfig'




const EventManagement = props => {
    const statusHeaders = ['Registered', 'Checked In', 'Cancelled']
    const userDetails = props.userDetails
    const [statusFilter, setStatusFilter] = useState(statusHeaders.map((e, index) => {
        return { name: e, filterState: true, color: '#b3b3b3', index }
    }))
    const [events, setEvents] = useState([])
    const [sessions, setSessions] = useState([])
    const [filteredRegistrations, setFilteredRegistrations] = useState([])
    // State tracker for Update Registration modal
    const [updateRegistration, setUpdateRegistration] = useState(false)
    const [registration, setRegistration] = useState('')
    const [eventId, setEventId] = useState('')
    const [sessionId, setSessionId] = useState(null)

    //Getting all Events using axios
    useEffect(() => {
        getEvents()
    }, [userDetails])

    useEffect(() => {
        if (sessionId) {
            filterRegistrations()
        }
    }, [statusFilter, sessionId])

    const filterRegistrations = () => {
        var filters = {}
        filters.status = statusFilter.filter(e => e.filterState).map(e => e.name)
        axios.post('/api/registrations/filter', { filter: { sessionId } }, tokenConfig())
            .then(res => {
                const arr = res.data.filter(registration => {
                    return Object.keys(filters).every(key => {
                        if (Array.isArray(filters[key])) {
                            return filters[key].includes(registration[key])
                        }
                        return filters[key] === registration[key]
                    })
                })
                setFilteredRegistrations(arr)
            })
            .catch(err => console.log(err))
    }

    useEffect(() => {
        setFilteredRegistrations([])
        if (eventId) {
            getEventSessions(eventId)
        }
    }, [eventId])

    const getEventSessions = async (eventId) => {
        setSessions([])
        await axios.post('/api/event-sessions/getSessionsByEventId', { eventId, filters: {} }, tokenConfig())
            .then(res => setSessions(res.data))
            .catch(err => console.log(err))
    }

    const changeFilterState = (index) => {
        const arr = statusFilter.map((e, i) => {
            if (i === index) {
                e.filterState = !e.filterState
                return e
            }
            return e
        })
        setStatusFilter(arr)
    }

    const getEvents = async () => {
        await axios.get('/api/events', tokenConfig())
            .then(res => setEvents(res.data))
            .catch(err => console.log(err))
    }

    const cancelRegistration = async _id => {
        const confirm = window.confirm("Cancel your registration?")
        if (!confirm) return console.log("Cancelled Request")
        await axios.delete(`/api/registrations/${_id}`, tokenConfig())
            .then(res => {
                filterRegistrations()
            })
            .catch(err => console.log(err))
    }


    return (
        <Fragment>
            <Row style={{ margin: '1rem' }}>
                <Col >
                    <Input type="select" onChange={e => setEventId(e.target.value)}>
                        <option value="">Select Event</option>
                        {events.sort((a, b) => a.name < b.name ? -1 : 1).map(({ _id, name }) => <option value={_id} key={_id}>{name}</option>)}
                    </Input>
                    <Input type="select" onChange={e => setSessionId(e.target.value)}>
                        <option value="">Select Session</option>
                        {sessions.map(({ _id, name, date, starttime, endtime }) => <option value={_id} key={_id}>{date?.substr(0, 10)}, {starttime}-{endtime}</option>)}
                    </Input>
                </Col>
                <Col>
                    <Table>
                        <tbody>
                            <tr>
                                {statusFilter.map(({ name, filterState, color, index }) => (
                                    <td
                                        key={name}
                                        width='20%'
                                        style={{
                                            opacity: filterState ? '1' : '0.3',
                                            backgroundColor: color,
                                            textAlign: 'center',
                                            border: '1px solid #969696',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => changeFilterState(index)}>
                                        {name}
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </Table>
                </Col>
                <Col><QrScanner updateStatus={filterRegistrations} /></Col>
                <Col><Button
                    onClick={filterRegistrations}
                    disabled={!sessionId}
                >Reload Data</Button></Col>
            </Row>
            <UpdateRegistration
                toggle={e => setUpdateRegistration(e)}
                updateRegistration={updateRegistration}
                registration={registration}
                insertUpdatedRegistration={filterRegistrations}
            />
            <RegistrationTable
                events={events}
                registrations={filteredRegistrations}
                setUpdateRegistration={setUpdateRegistration}
                cancelRegistration={cancelRegistration}
                setRegistration={setRegistration}
            />
        </Fragment>
    )
}

export default EventManagement